import { Link } from "react-router-dom";
import { categories } from "@/types/content";

const toneMap: Record<string, string> = {
  film: "bg-primary-50 text-primary-600",
  music: "bg-accent-50 text-accent-700",
  lifestyle: "bg-background-100 text-foreground-700",
  brand: "bg-secondary-50 text-secondary-700",
};

export default function CategoryQuickEntry() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-500">挑一个感兴趣的方向，马上开始逛</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat, idx) => (
          <Link
            key={cat.key}
            to={cat.path}
            style={{ animationDelay: `${idx * 70}ms` }}
            className="group animate-fade-up flex flex-col bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span
              className={`w-11 h-11 rounded-lg flex items-center justify-center ${toneMap[cat.key]}`}
            >
              <i className={`${cat.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
              {cat.name}
            </h3>
            <p className="mt-1 text-xs text-primary-600">{cat.tagline}</p>
            <p className="mt-3 text-sm text-foreground-600 line-clamp-2 flex-1">
              {cat.description}
            </p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-foreground-500 group-hover:text-primary-600 transition-colors">
              进入频道
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}